module.exports = __webpack_public_path__ + "img/Easy.5b5ba9c4.png";